export const surveysSelector = (state: any) => state.surveys;
